import {Injectable} from '@angular/core';
import {DataService} from '../data.service';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import { catchError } from 'rxjs/operators';
import {ControlKeys} from 'src/app/features/ratefile-open/control-keys';
import {RatesSroMaster} from 'src/app/shared/common-components/common-structure';
import {HhgRatesCsvDownload} from 'src/app/features/hhg-rates-csv-download/hhgRatesCsvDownload';

@Injectable({
  providedIn: 'root'
})
export class HhgRatesCsvDownloadService extends DataService {

  private baseURI = this.apiUri + '/ratefileopen/';
  private baseURIsro = this.apiUri + '/ratessromaster/';

  constructor(http: HttpClient) {
    super(http);
  }

  /*
   Purpose of this function is to get all effective dates
 */
  getEffectiveDates(controltype: string): Observable<ControlKeys[]> {
    this.setUri(this.baseURI + controltype + '/controltype/released');
    return this.get().pipe(catchError(this.handleError));
  }

  /*
   Purpose of this function is to get list of SRO's
   */
  getSros(businesstype: string): Observable<RatesSroMaster[]> {
    this.setUri(this.baseURIsro + 'srotypepojo/businesstype/' + businesstype);
    return this.get().pipe(catchError(this.handleError));
  }

  /**
   *
   * @param: controlId,carrierId,SRO list,Origin id, Destination id

   */
  exportDataFromServer2(ratesPoc: HhgRatesCsvDownload): any {
    return this.http.post(this.apiUri + '/rateshhg/downloadHhgRates/csv2/', ratesPoc, {responseType: 'text' as 'json'});
  }

  exportDataFromServerMultiThread(ratesPoc: HhgRatesCsvDownload): any {
    return this.http.post(this.apiUri + '/rateshhg/downloadHhgRates/csv3/', ratesPoc, {responseType: 'text' as 'json'});
  }

  exportDataFromServer(ratesPoc: HhgRatesCsvDownload): any {
    return this.http.post(this.apiUri + '/rateshhg/downloadHhgRates/csv/', ratesPoc, {responseType: 'text' as 'json'});
  }
}
